const Search = () => {
  return (
    <div>
      <button>검색하기</button>
    </div>
  )
}

export default Search;